import React from 'react'
import Homebanner from './Homebanner'
import Homesearch from './HomeSearch/Homesearch'
import Countryslide from './Countryslide/Countryslide'
import Homecategory from './Homecaegory/Homecategory'
import Newproducts from './Newproducts/Newproducts'
import Collection from './Collection'
import Trandingproducts from './Trendingproducts/Treandingproducts'


export default function () {
  return (
    <>
        <Homebanner/>
        <Homesearch/>
        <Countryslide/>
        <Homecategory/>
        <Newproducts/>
        <Collection/>
        <Trandingproducts/>
    </>
  )
}
